import BasePage from '@/found/components/table_page';

export default {
  name: 'detail',
  extends: BasePage,
  props: {
    paramsProps: Object,
  },
  data() {
    return {
      params: {
        reportRecordCode: this.paramsProps.reportRecordCode,
      },
    };
  },
  methods: {

  },
  created() {
    this.getConfigList('scan_record_list');
  },
};
